import styled from '@emotion/styled';
import { tabs } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';

export const TabsWrapper = styled('div', { label: 'TabsWrapper' })`
    display: flex;
    flex-flow: row nowrap;
`;

interface TabPropsType {
    isActive: boolean;
}

export const Tab = styled('button', { label: 'Tab' })<TabPropsType>`
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: ${({ isActive }): string => isActive ? fontWeight.bold : fontWeight.regular};
    line-height: 1.1428;
    margin: 0 25px;
    outline: none;
    padding: 0 0 8px;
    position: relative;
    &::after {
        background: ${({ isActive }): string => isActive ? tabs.slider.bgColor : 'transparent'};
        border-radius: 4px 4px 0 0;
        content: '';
        height: 4px;
        left: 5px;
        position: absolute;
        right: 5px;
        top: 100%;
    }
`;



